"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _utils = require("../../utils");
var _richTextField = require("../../lib/richTextField");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _sitecoreJssReact = require("@sitecore-jss/sitecore-jss-react");
var _imageSrc = require("../../lib/imageSrc");
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * A Hero component
 *
 * @param {object} props Properties used for the component
 *
 * @returns {React.ReactElement} A jumbotron/hero
 */
function Hero(props) {
  if (!props.rendering.fields) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var {
    linkUrl,
    linkTarget
  } = (0, _linkFieldSrc.linkFieldSrc)(extractedFields.Link.value);
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Jumbotron, {
    variant: extractedFields.Variant.value,
    backgroundImageUrl: (0, _imageSrc.imageHref)(extractedFields.BackgroundImage.value),
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("section", {
    className: "col-md-6 reverse"
  }, !(0, _lodash.isEmpty)(extractedFields.Title.value) && /*#__PURE__*/_react.default.createElement("h1", null, (0, _richTextField.parseHTML)(extractedFields.Title)), !(0, _lodash.isEmpty)(extractedFields.PreviewText.value) && /*#__PURE__*/_react.default.createElement("p", null, (0, _richTextField.parseHTML)(extractedFields.PreviewText)), /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: extractedFields.ButtonType.value,
    href: linkUrl,
    target: linkTarget,
    label: extractedFields.Text.value,
    icon: extractedFields.ctaIcon.value,
    iconDirection: extractedFields.ctaIconPlacement.value,
    dataId: extractedFields.ctaDataId.value
  }, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null)), !(0, _lodash.isEmpty)(extractedFields.CalloutText.value) && /*#__PURE__*/_react.default.createElement("div", {
    className: "copy-sm"
  }, (0, _richTextField.parseHTML)(extractedFields.CalloutText))), /*#__PURE__*/_react.default.createElement("section", {
    className: "offset-md-2 col-md-4"
  }, /*#__PURE__*/_react.default.createElement(_sitecoreJssReact.Placeholder, {
    name: "hero-card-content",
    rendering: props.rendering,
    params: props.params
  }))));
}
var _default = exports.default = Hero;